SupportBasePresentation = require('./base')
SupportNowStatusAndNotesPresentation = require('./now_messages')

class SupportNowPresenterPresentation extends SupportBasePresentation
	getLookupObject: () ->
		SupportNowStatusAndNotesPresentation

module.exports = SupportNowPresenterPresentation
